import { SITE_MAP } from 'globalConstants';
import {
  MARK_NOTIFICATIONS_AS_READ,
  MarkNotificationsAsReadData,
  MarkNotificationsAsReadVariables,
} from 'graphql/main/mutations/temp/mark-notification-as-read';
import { Notification, NotificationType } from 'graphql/main/queries/temp/get-list-notification';
import { useFlexMutation } from 'hooks';
import { find, isEqual, isNil } from 'lodash';
import moment from 'moment';
import { useRouter } from 'next/router';
import { timeSince } from 'utils';
import NewFriendRequest from './new-friend-request';

export const specialNotificationTypes = [
  {
    value: NotificationType.newComment,
    icon: '/icons/notifications/message.svg',
  },
  {
    value: NotificationType.replyComment,
    icon: '/icons/notifications/message.svg',
  },
  {
    value: NotificationType.newFriendRequest,
    icon: '/icons/notifications/friend.svg',
  },
  {
    value: NotificationType.likePost,
    icon: '/icons/notifications/like.svg',
  },
  {
    value: NotificationType.commentOnPost,
    icon: '/icons/notifications/message.svg',
  },
  {
    value: NotificationType.acceptedFriendRequest,
    icon: '/icons/notifications/friend.svg',
  },
  {
    value: NotificationType.likeComment,
    icon: '/icons/notifications/like.svg',
  },
];

interface Props {
  notification: Notification;
}

const NotificationPart = ({ notification }: Props) => {
  const router = useRouter();
  const configs = [
    {
      value: 'newFriendRequest',
      content: <NewFriendRequest notification={notification} />,
    },
  ];
  const [markNotificationsAsRead] = useFlexMutation<
    MarkNotificationsAsReadData,
    MarkNotificationsAsReadVariables
  >('main', MARK_NOTIFICATIONS_AS_READ);

  const goToNotification = async () => {
    if (!isNil((notification?.payload as any)?.type)) {
      router.push(
        `/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.REAL_ESTATE_POST.INDEX}/${(
          notification?.payload as any
        )?.postId}`,
      );
    }
    if (!isNil((notification?.payload as any)?.friendStatus)) {
      router.push(
        `/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.SOCIAL_PROFILE}/${(
          notification?.payload as any
        ).user?.id}`,
      );
    }
    router.push(
      `/${SITE_MAP.SOCIAL_NETWORK.INDEX}/${SITE_MAP.SOCIAL_NETWORK.COMMUNITY_POST}/${(
        notification?.payload as any
      )?.postId}`,
    );
    if (notification.id) {
      await markNotificationsAsRead({
        variables: { notificationIds: [notification.id] },
      });
    }
  };

  return (
    <div
      className='max-h-[auto] min-h-[76px] w-full cursor-pointer rounded-[8px] hover:bg-secondary'
      onClick={goToNotification}
    >
      <div className='flex'>
        <div className='relative flex w-full flex-1 space-x-[12px] py-[10px]'>
          <div className='ml-[24px] h-[48px] w-[48px]'>
            <div className='h-[48px] w-[48px] overflow-hidden rounded-full'>
              <img
                src={
                  (notification?.payload as any)?.user?.avatar?.originalUrl ??
                  '/images/default-avatar.svg'
                }
                alt='avatar'
                loading='lazy'
                className='h-full w-full object-cover'
              />
            </div>
            <div className='absolute left-[12px] top-[10px] h-[24px] w-[24px] overflow-hidden rounded-full'>
              <img
                src={
                  find(specialNotificationTypes, (specialNotificationType) =>
                    isEqual(specialNotificationType.value, notification.type),
                  )?.icon ?? '/icons/notifications/error.svg'
                }
                alt={
                  find(specialNotificationTypes, (specialNotificationType) =>
                    isEqual(specialNotificationType.value, notification.type),
                  )?.icon ?? '/icons/notifications/error.svg'
                }
                loading='lazy'
                className='h-full w-full object-cover'
              />
            </div>
          </div>
          <div className='flex-1'>
            <div className='flex h-full w-full flex-col space-y-[6px]'>
              <span>
                <span className='font-[600]'>{(notification?.payload as any)?.user?.name}</span>{' '}
                {isEqual((notification?.payload as any)?.number, 0) ||
                isNil((notification?.payload as any)?.number) ? null : (
                  <span>và {(notification?.payload as any)?.number} người khác</span>
                )}{' '}
                <span>{notification.title}</span>
              </span>
              <span className='text-[12px] leading-[15px] text-text2'>
                {timeSince(moment(notification.createdAt).toDate())}
              </span>
              {find(configs, (config) => isEqual(config.value, notification.type))?.content}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationPart;

export const NotificationSkeleton = () => (
  <div className='flex space-x-[12px] h-[69px] py-[10px] animate-pulse'>
    <div className='ml-[24px] h-[48px] min-w-[48px] rounded-full bg-secondary' />
    <div className='flex flex-col w-full space-y-[6px]'>
      <div className='h-[18px] w-full bg-secondary' />
      <div className='h-[15px] w-[100px] bg-secondary' />
    </div>
  </div>
);
